module.exports = __webpack_public_path__ + "img/71.6.CODm.058a4775.png";